export const PAGE_TYPES = new Set(['Page', 'MasterPage']);
export const TYPE_TO_COMP_TYPE = {
    Image: 'core.components.Image',
    MenuButton: 'core.components.MenuButton',
    Page: 'mobile.core.components.Page',
    MasterPage: 'mobile.core.components.MasterPage',
    AppPage: 'wixapps.integration.components.AppPage',
    AppPart: 'wixapps.integration.components.AppPart',
    AppPart2: 'wixapps.integration.components.AppPart2',
    TextInput: 'wysiwyg.viewer.components.inputs.TextInput',
    DropDownMenu: 'wysiwyg.viewer.components.menus.DropDownMenu',
    Icon: 'wixapps.integration.components.Icon',
    'wixapps.integration.components.ImageButton': 'wixapps.integration.components.ImageButton',
    RSSButton: 'wysiwyg.common.components.rssbutton.viewer.RSSButton',
    Anchor: 'wysiwyg.common.components.anchor.viewer.Anchor',
    VerticalAnchorsMenu: 'wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu',
    FacebookLikeBox: 'wysiwyg.common.components.facebooklikebox.viewer.FacebookLikeBox',
    'wysiwyg.common.components.imagebutton.viewer.ImageButton': 'wysiwyg.common.components.imagebutton.viewer.ImageButton',
    OptionsListInput: 'wysiwyg.common.components.inputs.OptionsListInput',
    SelectOptionsList: 'wysiwyg.common.components.inputs.SelectOptionsList',
    PinItPinWidget: 'wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget',
    PinterestPinIt: 'wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt',
    SingleAudioPlayer: 'wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer',
    SkypeCallButton: 'wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton',
    SpotifyFollow: 'wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow',
    SpotifyPlayer: 'wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer',
    SubscribeForm: 'wysiwyg.common.components.subscribeform.viewer.SubscribeForm',
    VerticalMenu: 'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu',
    YouTubeSubscribeButton: 'wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton',
    AdminLoginButton: 'wysiwyg.viewer.components.AdminLoginButton',
    AudioPlayer: 'wysiwyg.viewer.components.AudioPlayer',
    BgImageStrip: 'wysiwyg.viewer.components.BgImageStrip',
    ClipArt: 'wysiwyg.viewer.components.ClipArt',
    ContactForm: 'wysiwyg.viewer.components.ContactForm',
    DynamicContactForm: 'wysiwyg.viewer.components.DynamicContactForm',
    Displayer: 'wysiwyg.viewer.components.Displayer',
    DocumentMedia: 'wysiwyg.viewer.components.documentmedia.DocumentMedia',
    EbayItemsBySeller: 'wysiwyg.viewer.components.EbayItemsBySeller',
    FacebookShare: 'wysiwyg.viewer.components.FacebookShare',
    FlashComponent: 'wysiwyg.viewer.components.FlashComponent',
    FlickrBadgeWidget: 'wysiwyg.viewer.components.FlickrBadgeWidget',
    GoogleMap: 'wysiwyg.viewer.components.GoogleMap',
    HtmlComponent: 'wysiwyg.viewer.components.HtmlComponent',
    ItunesButton: 'wysiwyg.viewer.components.ItunesButton',
    LinkBar: 'wysiwyg.viewer.components.LinkBar',
    LinkBarItem: 'wysiwyg.viewer.components.LinkBarItem',
    LoginButton: 'wysiwyg.viewer.components.LoginButton',
    LoginSocialBar: 'wysiwyg.viewer.components.LoginSocialBar',
    MatrixGallery: 'wysiwyg.viewer.components.MatrixGallery',
    MediaRichText: 'wysiwyg.viewer.components.MediaRichText',
    PayPalButton: 'wysiwyg.viewer.components.PayPalButton',
    PinterestFollow: 'wysiwyg.viewer.components.PinterestFollow',
    SiteButton: 'wysiwyg.viewer.components.SiteButton',
    SliderGallery: 'wysiwyg.viewer.components.SliderGallery',
    SlideShowGallery: 'wysiwyg.viewer.components.SlideShowGallery',
    SoundCloudWidget: 'wysiwyg.viewer.components.SoundCloudWidget',
    TwitterFeed: 'wysiwyg.viewer.components.TwitterFeed',
    VerticalRepeater: 'wysiwyg.viewer.components.VerticalRepeater',
    Video: 'wysiwyg.viewer.components.Video',
    VKShareButton: 'wysiwyg.viewer.components.VKShareButton',
    WPhoto: 'wysiwyg.viewer.components.WPhoto',
    WRichText: 'wysiwyg.viewer.components.WRichText',
    WTwitterFollow: 'wysiwyg.viewer.components.WTwitterFollow',
    WTwitterTweet: 'wysiwyg.viewer.components.WTwitterTweet',
    ComboBoxInput: 'wysiwyg.viewer.components.inputs.ComboBoxInput',
    TextOption: 'wysiwyg.viewer.components.inputs.TextOption',
    MobileTextOption: 'ecommerce.integration.components.MobileTextOption',
    ColorOption: 'wysiwyg.viewer.components.inputs.ColorOption',
    MobileColorOption: 'ecommerce.integration.components.MobileColorOption',
    TinyMenu: 'wysiwyg.viewer.components.mobile.TinyMenu',
    ExpandableMenu: 'wysiwyg.viewer.components.ExpandableMenu',
    QuickActionBar: 'wysiwyg.viewer.components.QuickActionBar',
    QuickActionBarItem: 'wysiwyg.viewer.components.QuickActionBarItem',
    Collage: 'tpa.viewer.components.Collage',
    Freestyle: 'tpa.viewer.components.Freestyle',
    TouchMediaZoom: 'wysiwyg.viewer.components.TouchMediaZoom',
    TouchMediaZoomItem: 'wysiwyg.viewer.components.TouchMediaZoomItem',
    Honeycomb: 'tpa.viewer.components.Honeycomb',
    Masonry: 'tpa.viewer.components.Masonry',
    TPA3DCarousel: 'wysiwyg.viewer.components.tpapps.TPA3DCarousel',
    TPA3DGallery: 'wysiwyg.viewer.components.tpapps.TPA3DGallery',
    StripShowcase: 'tpa.viewer.components.StripShowcase',
    StripSlideshow: 'tpa.viewer.components.StripSlideshow',
    Thumbnails: 'tpa.viewer.components.Thumbnails',
    Accordion: 'tpa.viewer.components.Accordion',
    Impress: 'tpa.viewer.components.Impress',
    ExitMobileMode: 'wysiwyg.common.components.exitmobilemode.viewer.ExitMobileMode',
    NumericStepper: 'wysiwyg.common.components.NumericStepper',
    FiveGridLine: 'wysiwyg.viewer.components.FiveGridLine',
    PageGroup: 'wysiwyg.viewer.components.PageGroup',
    PaginatedGridGallery: 'wysiwyg.viewer.components.PaginatedGridGallery',
    WFacebookComment: 'wysiwyg.viewer.components.WFacebookComment',
    DisqusComments: 'wysiwyg.common.components.disquscomments.viewer.DisqusComments',
    WFacebookLike: 'wysiwyg.viewer.components.WFacebookLike',
    WGooglePlusOne: 'wysiwyg.viewer.components.WGooglePlusOne',
    SvgShape: 'wysiwyg.viewer.components.svgshape.SvgShape',
    VectorImage: 'wysiwyg.viewer.components.VectorImage',
    SvgPrimitive: 'wysiwyg.viewer.components.svgPrimitive.SvgPrimitive',
    SiteRegionContainer: 'wysiwyg.viewer.components.SiteRegionContainer',
    Container: 'mobile.core.components.Container',
    SlotsPlaceholder: 'wixui.SlotsPlaceholder',
    MediaBox: 'wysiwyg.viewer.components.MediaBox',
    HoverBox: 'wysiwyg.viewer.components.HoverBox',
    PopupContainer: 'wysiwyg.viewer.components.PopupContainer',
    PopupCloseTextButton: 'wysiwyg.viewer.components.PopupCloseTextButton',
    PopupCloseIconButton: 'wysiwyg.viewer.components.PopupCloseIconButton',
    Group: 'wysiwyg.viewer.components.Group',
    FormContainer: 'wysiwyg.viewer.components.FormContainer',
    WSiteStructure: 'wysiwyg.viewer.components.WSiteStructure',
    HeaderContainer: 'wysiwyg.viewer.components.HeaderContainer',
    FooterContainer: 'wysiwyg.viewer.components.FooterContainer',
    PagesContainer: 'wysiwyg.viewer.components.PagesContainer',
    StripContainer: 'wysiwyg.viewer.components.StripContainer',
    StripColumnsContainer: 'wysiwyg.viewer.components.StripColumnsContainer',
    ClassicSection: 'wysiwyg.viewer.components.ClassicSection',
    Column: 'wysiwyg.viewer.components.Column',
    MediaPlayer: 'wysiwyg.viewer.components.MediaPlayer',
    MediaOverlayControls: 'wysiwyg.viewer.components.MediaOverlayControls',
    MediaControls: 'wysiwyg.viewer.components.MediaControls',
    MediaControlPlay: 'wysiwyg.viewer.components.MediaControlPlay',
    MediaControlVolume: 'wysiwyg.viewer.components.MediaControlVolume',
    MediaControlFullscreen: 'wysiwyg.viewer.components.MediaControlFullscreen',
    MediaControlProgress: 'wysiwyg.viewer.components.MediaControlProgress',
    MediaControlTime: 'wysiwyg.viewer.components.MediaControlTime',
    MediaControlStoryboard: 'wysiwyg.viewer.components.MediaControlStoryboard',
    ScreenWidthContainer: 'wysiwyg.viewer.components.ScreenWidthContainer',
    VerticalLine: 'wysiwyg.viewer.components.VerticalLine',
    TPAGluedWidget: 'wysiwyg.viewer.components.tpapps.TPAGluedWidget',
    TPAWidget: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    TPASection: 'wysiwyg.viewer.components.tpapps.TPASection',
    TPAMultiSection: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    'wysiwyg.common.components.backtotopbutton.viewer.BackToTopButton': 'wysiwyg.common.components.backtotopbutton.viewer.BackToTopButton',
    'wysiwyg.viewer.components.BackToTopButton': 'wysiwyg.viewer.components.BackToTopButton',
    SiteBackground: 'wysiwyg.viewer.components.SiteBackground',
    EnterPasswordDialog: 'wysiwyg.viewer.components.dialogs.EnterPasswordDialog',
    NotificationDialog: 'wysiwyg.viewer.components.dialogs.NotificationDialog',
    SignUpDialog: 'wysiwyg.viewer.components.dialogs.siteMemberDialogs.SignUpDialog',
    MemberLoginDialog: 'wysiwyg.viewer.components.dialogs.siteMemberDialogs.MemberLoginDialog',
    RequestPasswordResetDialog: 'wysiwyg.viewer.components.dialogs.siteMemberDialogs.RequestPasswordResetDialog',
    ResetPasswordDialog: 'wysiwyg.viewer.components.dialogs.siteMemberDialogs.ResetPasswordDialog',
    EcomCheckoutMessageDialog: 'ecommerce.viewer.dialogs.EcomCheckoutMessageDialog',
    ZoomedImage: 'core.components.ZoomedImage',
    imageZoom: 'wysiwyg.components.imageZoom',
    ImageZoomDisplayer: 'wysiwyg.components.ImageZoomDisplayer',
    AppPartZoom: 'wixapps.integration.components.AppPartZoom',
    MediaZoom: 'wysiwyg.viewer.components.MediaZoom',
    MobileMediaZoom: 'wysiwyg.viewer.components.MobileMediaZoom',
    ErasableTextInput: 'wysiwyg.viewer.components.inputs.ErasableTextInput',
    InfoTip: 'wysiwyg.common.components.InfoTip',
    InputWithValidation: 'wysiwyg.components.viewer.inputs.InputWithValidation',
    MessageView: 'wysiwyg.viewer.components.MessageView',
    Area: 'wixapps.integration.components.Area',
    TextAreaInput: 'wysiwyg.viewer.components.inputs.TextAreaInput',
    TextArea: 'wixapps.integration.components.inputs.TextArea',
    Toggle: 'wixapps.integration.components.Toggle',
    MobileActionsMenu: 'wysiwyg.viewer.components.MobileActionsMenu',
    Table: 'wysiwyg.viewer.components.Table',
    TPAModal: 'wysiwyg.viewer.components.tpapps.TPAModal',
    TPAPopup: 'wysiwyg.viewer.components.tpapps.TPAPopup',
    TPAPreloaderOverlay: 'wysiwyg.viewer.components.tpapps.TPAPreloaderOverlay',
    TPAUnavailableMessageOverlay: 'wysiwyg.viewer.components.tpapps.TPAUnavailableMessageOverlay',
    TPAWorker: 'tpa.viewer.classes.TPAWorker',
    TPAPlaceholder: 'wysiwyg.viewer.components.tpapps.TPAPlaceholder',
    CloudGluedWidget: 'wysiwyg.viewer.components.cloud.CloudGluedWidget',
    CloudWidget: 'wysiwyg.viewer.components.cloud.CloudWidget',
    bgMedia: 'wysiwyg.viewer.components.background.bgMedia',
    bgImage: 'wysiwyg.viewer.components.background.bgImage',
    html5Video: 'wysiwyg.viewer.components.background.html5Video',
    webglMedia: 'wysiwyg.viewer.components.background.webglMedia',
    iframeVideo: 'wysiwyg.viewer.components.background.iframeVideo',
    bgOverlay: 'wysiwyg.viewer.components.background.bgOverlay',
    BoxSlideShow: 'wysiwyg.viewer.components.BoxSlideShow',
    StateBox: 'wysiwyg.viewer.components.StateBox',
    StateStrip: 'wysiwyg.viewer.components.StateStrip',
    StateBoxState: 'wysiwyg.viewer.components.StateBoxState',
    StateBoxFormState: 'wysiwyg.viewer.components.StateBoxFormState',
    StateStripState: 'wysiwyg.viewer.components.StateStripState',
    StripContainerSlideShow: 'wysiwyg.viewer.components.StripContainerSlideShow',
    BoxSlideShowSlide: 'wysiwyg.viewer.components.BoxSlideShowSlide',
    StripContainerSlideShowSlide: 'wysiwyg.viewer.components.StripContainerSlideShowSlide',
    Checkbox: 'wysiwyg.viewer.components.inputs.Checkbox',
    RadioButton: 'wysiwyg.viewer.components.inputs.RadioButton',
    RadioGroup: 'wysiwyg.viewer.components.inputs.RadioGroup',
    CheckboxGroup: 'wysiwyg.viewer.components.inputs.CheckboxGroup',
    FileUploader: 'wysiwyg.viewer.components.inputs.FileUploader',
    uploadName: 'wysiwyg.viewer.components.inputs.uploadName',
    DatePicker: 'wysiwyg.viewer.components.inputs.DatePicker',
    ImageButtonWithText: 'wysiwyg.viewer.components.ImageButtonWithText',
    Grid: 'wysiwyg.viewer.components.Grid',
    Repeater: 'wysiwyg.viewer.components.Repeater',
    MediaContainer: 'wysiwyg.viewer.components.MediaContainer',
    InlinePopup: 'wysiwyg.viewer.components.InlinePopup',
    MenuContainer: 'wysiwyg.viewer.components.MenuContainer',
    InlinePopupToggle: 'wysiwyg.viewer.components.InlinePopupToggle',
    MenuToggle: 'wysiwyg.viewer.components.MenuToggle',
    AppController: 'platform.components.AppController',
    AppWidget: 'platform.components.AppWidget',
    LanguageSelector: 'wysiwyg.viewer.components.LanguageSelector',
    Popover: 'wysiwyg.viewer.components.Popover',
    RefComponent: 'wysiwyg.viewer.components.RefComponent',
    Section: 'responsive.components.Section',
    HeaderSection: 'responsive.components.HeaderSection',
    FooterSection: 'responsive.components.FooterSection',
    MembersAreaSection: 'responsive.components.MembersAreaSection',
    MultiStateBox: 'wixui.MultiStateBox',
    MobuiButton: 'mobui.MobuiButton',
    MobuiImage: 'mobui.MobuiImage',
    MobuiPicker: 'mobui.MobuiPicker',
    MobuiSwitch: 'mobui.MobuiSwitch',
    MobuiText: 'mobui.MobuiText',
    MobuiTextInput: 'mobui.MobuiTextInput',
    MobuiContainer: 'mobui.MobuiContainer',
    Logo: 'wixui.Logo',
    ShareButtons: 'wixui.ShareButtons',
    AccordionContainer: 'wixui.AccordionContainer',
    AccordionItem: 'wixui.AccordionItem',
    AddressInput: 'wixui.AddressInput',
    BoltComponent: 'wixui.BoltComponent',
    Breadcrumbs: 'wixui.Breadcrumbs',
    Captcha: 'wixui.Captcha',
    CollapsibleText: 'wixui.CollapsibleText',
    CustomElementComponent: 'wixui.CustomElementComponent',
    DynamicRepeater: 'wixui.DynamicRepeater',
    ExternalComponent: 'wixui.ExternalComponent',
    FastGallery: 'wixui.FastGallery',
    HamburgerCloseButton: 'wixui.HamburgerCloseButton',
    HamburgerMenuContainer: 'wixui.HamburgerMenuContainer',
    HamburgerMenuContent: 'wixui.HamburgerMenuContent',
    HamburgerMenuRoot: 'wixui.HamburgerMenuRoot',
    HamburgerOpenButton: 'wixui.HamburgerOpenButton',
    HamburgerOverlay: 'wixui.HamburgerOverlay',
    ImageX: 'wixui.ImageX',
    LineShareButton: 'wixui.LineShareButton',
    LottieEmbed: 'wixui.LottieEmbed',
    MegaMenuContainerItem: 'wixui.MegaMenuContainerItem',
    Menu: 'wixui.Menu',
    MusicPlayer: 'wixui.MusicPlayer',
    OldBlogDeprecation: 'wixui.OldBlogDeprecation',
    Pagination: 'wixui.Pagination',
    ProductSpecification: 'wixui.ProductSpecification',
    ProGallery: 'wixui.ProGallery',
    ProgressBar: 'wixui.ProgressBar',
    RangeSlider: 'wixui.RangeSlider',
    RatingsDisplay: 'wixui.RatingsDisplay',
    RatingsInput: 'wixui.RatingsInput',
    RichContentViewer: 'wixui.RichContentViewer',
    RichTextBox: 'wixui.RichTextBox',
    SearchBox: 'wixui.SearchBox',
    SearchButton: 'wixui.SearchButton',
    SelectableContainer: 'wixui.SelectableContainer',
    SelectableContainerInput: 'wixui.SelectableContainerInput',
    SelectionTagsList: 'wixui.SelectionTagsList',
    SignatureInput: 'wixui.SignatureInput',
    SingleTab: 'wixui.SingleTab',
    Slider: 'wixui.Slider',
    Slideshow: 'wixui.Slideshow',
    SlideshowButton: 'wixui.SlideshowButton',
    SlideshowItem: 'wixui.SlideshowItem',
    SocialAuth: 'wixui.SocialAuth',
    StretchedContainer: 'wixui.StretchedContainer',
    StylableButton: 'wixui.StylableButton',
    StylableHorizontalMenu: 'wixui.StylableHorizontalMenu',
    Submenu: 'wixui.Submenu',
    SvgImage: 'wixui.SvgImage',
    Tabs: 'wixui.Tabs',
    TestComp: 'wixui.TestComp',
    TextMarquee: 'wixui.TextMarquee',
    TextMask: 'wixui.TextMask',
    TimePicker: 'wixui.TimePicker',
    ToggleSwitch: 'wixui.ToggleSwitch',
    UnsupportedComponent: 'wixui.UnsupportedComponent',
    VideoPlayer: 'wixui.VideoPlayer',
    ControlTypes: 'dsgnsys.ControlTypes',
    WutRadioButton: 'dsgnsys.WutRadioButton',
    DashboardButton: 'dsgnsys.DashboardButton',
    DashboardHeading: 'dsgnsys.DashboardHeading',
    DashboardIconButton: 'dsgnsys.DashboardIconButton',
    DashboardInfoIcon: 'dsgnsys.DashboardInfoIcon',
    DashboardInput: 'dsgnsys.DashboardInput',
    DashboardNumberInput: 'dsgnsys.DashboardNumberInput',
    DashboardText: 'dsgnsys.DashboardText',
    DashboardTextButton: 'dsgnsys.DashboardTextButton',
    DashboardToggleSwitch: 'dsgnsys.DashboardToggleSwitch',
    SettingsPanelContainer: 'dsgnsys.SettingsPanelContainer',
    WbuAccordion: 'dsgnsys.WbuAccordion',
    WbuBackButton: 'dsgnsys.WbuBackButton',
    WbuButton: 'dsgnsys.WbuButton',
    WbuCheckboxGroup: 'dsgnsys.WbuCheckboxGroup',
    WbuColorPicker: 'dsgnsys.WbuColorPicker',
    WbuColorSelector: 'dsgnsys.WbuColorSelector',
    WbuColumnControllerControl: 'dsgnsys.WbuColumnControllerControl',
    WbuDatePicker: 'dsgnsys.WbuDatePicker',
    WbuDrillDown: 'dsgnsys.WbuDrillDown',
    WbuDropdown: 'dsgnsys.WbuDropdown',
    WbuEmptyState: 'dsgnsys.WbuEmptyState',
    WbuFontAndColorPicker: 'dsgnsys.WbuFontAndColorPicker',
    WbuHorizontalTabs: 'dsgnsys.WbuHorizontalTabs',
    WbuLeftTextButton: 'dsgnsys.WbuLeftTextButton',
    WbuMultilineTextInput: 'dsgnsys.WbuMultilineTextInput',
    WbuNotificationBanner: 'dsgnsys.WbuNotificationBanner',
    WbuNumericInput: 'dsgnsys.WbuNumericInput',
    WbuRadioButtonGroup: 'dsgnsys.WbuRadioButtonGroup',
    WbuRichText: 'dsgnsys.WbuRichText',
    WbuSectionDivider: 'dsgnsys.WbuSectionDivider',
    WbuSlider: 'dsgnsys.WbuSlider',
    WbuTextInput: 'dsgnsys.WbuTextInput',
    WbuThumbnails: 'dsgnsys.WbuThumbnails',
    WbuToggleSwitch: 'dsgnsys.WbuToggleSwitch',
    WutAvatar: 'dsgnsys.WutAvatar',
    WutAvatarGroup: 'dsgnsys.WutAvatarGroup',
    WutBadge: 'dsgnsys.WutBadge'
};
